import './Loader.scss';

export const Loader = () => (
    <div className='loader'>
        <div className='loader__content'></div>
    </div>
);
